// 各项全局常量  cdn静态资源配置
const STATICURL = 'http://www.shlyszy.com'; //静态资源地址 ***正式上线必须换成自己的***
export {
    STATICURL,
}
